/* eslint-disable camelcase */
import $ from 'jquery';
import CITIES from './config/cities-with-countries';
import getClosest from './utilities/get-closest.js';
import substringMatcher from './utilities/substring-matcher';
import { MC_SIGNUP_FORMS, SELECTORS } from './config/app';
import './modules/typeahead.jquery.js';
import 'sass/index'; // Import CSS

// Polyfill
require('smoothscroll-polyfill').polyfill();


/*
    Ensure polyfills only load on older browsers
 */
// Covers all IE versions and Safari < 11
const browserSupportsAllFeatures = window.Promise && window.fetch;

if (browserSupportsAllFeatures) {
    initialise();
} else {
    // See 'Code Splitting' documentation for Webpack (https://webpack.js.org/guides/code-splitting-require/#dependencies)
    require.ensure([], function() {
        require('./polyfills.js');
        initialise();
    });
}


/*
    Main function
 */
function initialise() {
    /*
        Smoooth Scroll
     */
    const scrollButtons = document.querySelectorAll(SELECTORS.scrollButton);

    if (scrollButtons.length > 0) {
        scrollButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                const target = event.target.closest(SELECTORS.scrollButton);
                const anchor = document.querySelector(target.getAttribute('href'));
                const scrollTop = anchor.getBoundingClientRect().top + window.scrollY;

                window.scroll({
                    top: scrollTop,
                    left: 0,
                    behavior: 'smooth'
                });
            });
        });
    }


    /*
        Register Toggle
     */
    const accountTypeInputs = document.querySelectorAll(SELECTORS.accountTypeInput);
    const registerAsButtons = document.querySelectorAll(SELECTORS.registerAsButton);
    const conditionalFields = document.querySelectorAll(SELECTORS.conditionalField);

    if (accountTypeInputs.length > 0 && registerAsButtons.length > 0) {
        // Add register button scroll to and set
        registerAsButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                const target = getClosest(SELECTORS.registerAsButton, event.target);
                if (!target) return;

                // Set account type
                const accountType = target.getAttribute('data-account');
                accountTypeInputs.forEach((input) => {
                    // Pass true/false to inputs
                    if (input.getAttribute('value') === accountType) {
                        input.checked = true;
                        updateRegisterationAccount(accountType);
                    } else {
                        input.checked = false;
                    }
                });
            });
        });

        // Add change events on
        accountTypeInputs.forEach((input) => {
            input.addEventListener('change', (event) => {
                const target = getClosest(SELECTORS.accountTypeInput, event.target);

                if (target.checked === true) {
                    updateRegisterationAccount(target.getAttribute('value'));
                }
            });
        });
    }

    function updateRegisterationAccount(accountType) {
        const formAction = MC_SIGNUP_FORMS[accountType];

        if (!formAction) return;

        // Show/hide conidtional fields
        if (conditionalFields.length > 0) {
            conditionalFields.forEach((field) => {
                const fieldInputs = field.querySelectorAll(SELECTORS.field);

                if (field.getAttribute('data-for') === accountType) {
                    // Show
                    field.classList.remove('is-hidden');
                    // Make required and un-disabled
                    fieldInputs.forEach((input) => {
                        input.required = true;
                        input.disabled = false;
                    });
                } else {
                    // Hide
                    field.classList.add('is-hidden');
                    // Make un-required and disabled
                    fieldInputs.forEach((input) => {
                        input.required = false;
                        input.disabled = true;
                    });
                }
            });
        }

        console.log([
            `updateAccountType: ${accountType}`,
            formAction
        ]);

        $registerForm.attr('action', formAction);
    }


    /*
        Search Cities
     */
    const searchCitiesInput = document.querySelector(SELECTORS.searchCitiesInput);
    const TYPEAHEAD = 'typeahead';

    if (searchCitiesInput) {
        $(SELECTORS.searchCitiesInput).typeahead({
            minLength: 2,
            highlight: true,
            classNames: {
                cursor:      `${TYPEAHEAD}-cursor`,
                dataset:     `${TYPEAHEAD}-dataset`,
                empty:       `${TYPEAHEAD}-empty`,
                highlight:   `${TYPEAHEAD}-highlight`,
                hint:        `${TYPEAHEAD}-hint`,
                input:       `${TYPEAHEAD}-input`,
                menu:        `${TYPEAHEAD}-menu`,
                open:        `${TYPEAHEAD}-open`,
                selectable:  `${TYPEAHEAD}-selectable`,
                suggestion:  `${TYPEAHEAD}-suggestion`
            }
        }, {
            // Only load the common cities not a full list of the world
            name: 'common-cities',
            source: substringMatcher(CITIES)
        });
    }


    /*
        Submission Form
     */
    const $registerForm = $(SELECTORS.registerForm);
    const $registerFormSuccessModal = $(SELECTORS.registerFormSuccessModal);

    const showRegistrationFormSuccessHash = 'registration-complete'; // Matches index.html
    const LOCAL_STORAGE_KEYS = {
        registerationData: 'registerationData'
    };

    // Save form data to local storage
    $registerForm.submit(() => {
        // Get fields to save with local storage
        const formSessionData = {
            'name': $('[name="FNAME"]').val() + ' ' + $('[name="LNAME"]').val(), // eslint-disable-line prefer-template
            'email': $('[name="EMAIL"]').val()
        };

        localStorage.removeItem(LOCAL_STORAGE_KEYS.registerationData);
        localStorage.setItem(LOCAL_STORAGE_KEYS.registerationData, JSON.stringify(formSessionData));
    });

    // Close form and remove hash location
    $(SELECTORS.registerFormSuccessModalCloseButton).click((event) => {
        event.preventDefault();

        $registerFormSuccessModal.addClass('is-hidden');

        // Remove hash
    });

    // Show form success message
    function showRegistrationFormSuccess() {
        // Show the success message
        const registerationData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.registerationData)) || null;

        if (registerationData) {
            // Populate response fields using local storage
            $('[data-local="name"]').text(registerationData.name);
            $('[data-local="email"]').text(registerationData.email);

            // Show modal
            $registerFormSuccessModal.removeClass('is-hidden');
        }
    }


    /*
        Success Message
     */
    $(document).ready(() => {
        const hashLocation = window.location.hash.substr(1) || '';

        if (hashLocation === showRegistrationFormSuccessHash) showRegistrationFormSuccess();
    });
}



// WEBPACK FOOTER //
// ./client/js/index.js